import React from 'react'
import { NavLink } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import privicy from '../images/Privacy-Policy.png'
function Privacy() {
    return (
        <div>
            <Helmet>
                <title>Parcelx - Privacy Policy</title>
            </Helmet>
            <section className='section01 pb-0 trmsss'>
                <div className='container-fluid'>
                    <div className='col-md-11 mx-auto'>
                        <div className="row align-items-center">
                        <div className="col-md-6 order-md-2 text-md-end">
                            <img src={privicy} height="350" alt="" />
                        </div>
                        <div className="col-lg-6">
                            <h1 className="display-3">Privacy Policy Introduction</h1>
                        </div>
                    </div>
                    </div>
                </div>
            </section>
            <section className='section02 pt-0 trmsss'>
                <div className='container-fluid'>
                    <div className='col-md-11 mx-auto'>
                        <p className="text-muted">Exyte Solutions Private Limited (ParcelX) (“we”, “us”, “our”), a shipping aggregator operated by Exyte Solutions Private Limited, values your trust and is committed to protecting your privacy. This Privacy Policy explains how we collect, use, process, share, and secure your data when you use our website <NavLink to="/" className="d-inline-block">https://parcelx.in</NavLink>, mobile app, and services.
                            <br/><br/>
                            We comply with the Digital Personal Data Protection Act (DPDPA) 2023, IT Act 2000 & IT Rules 2011, and applicable international standards including GDPR principles.
                            <br/><br/>
                            By using our services, you consent to the practices described in this policy.
                        </p>
                        <h3>Information We Collect</h3>
                        <p>We may collect the following categories of data:</p>
                        <p><span>Personal Identifiable Information (PII)</span></p>
                        <ul>
                        <li>Full Name, Phone Number, Email Address</li>
                        <li>KYC Information: PAN, Aadhaar, GSTIN, Passport (where required)</li>
                        <li>Billing & Shipping Addresses</li>
                        <li>Bank Account/UPI details (for COD remittance)</li>
                        </ul>
                        <p><span>Business & Shipment Data</span></p>
                        <ul>
                        <li>Order IDs, AWB/Tracking Numbers</li>
                        <li>Product category/type, dimensions, weight</li>
                        <li>Courier preference and routing data</li>
                        </ul>
                        <p><span>Technical Data</span></p>
                        <ul>
                        <li>Device & browser type, IP address, location data</li>
                        <li>Login timestamps, usage logs, cookies</li>
                        </ul>
                        <p><span>Sensitive Personal Data (if applicable)</span></p>
                        <ul>
                        <li>Identity proofs for regulatory compliance</li>
                        <li>Financial credentials (encrypted & tokenized)</li>
                        </ul>
                        <h3>How We Use Your Information</h3>
                        <p>We process data strictly for service provision, including:</p>
                        <ul>
                        <li>Pickup, packaging, courier allocation, and order tracking</li>
                        <li>Account registration, onboarding, and verification (KYC)</li>
                        <li>Courier invoicing, COD collection, and remittance</li>
                        <li>Fraud detection, security monitoring, and legal compliance</li>
                        <li>Service improvement, analytics, and reporting</li>
                        <li>Notifications, alerts, and customer communication</li>
                        <li>Compliance with regulatory, tax, and government requests</li>
                        </ul>
                        <p>We do not use customer shipment data for profiling, marketing, or resale.</p>
                        <h3>Data Sharing & Disclosure</h3>
                        <p>We never sell or rent personal data. Information may be shared only with:</p>
                        <ul>
                        <li>Courier Partners (e.g., Delhivery, DTDC, Bluedart, XpressBees, India Post, FedEx): For delivery execution</li>
                        <li>Technology Vendors: Cloud hosting, API connectors, payment gateways (with signed DPAs)</li>
                        <li>Financial Institutions: For COD settlement and reconciliations</li>
                        <li>Government Authorities: Where legally mandated under Indian law</li>
                        <li>Amazon SP-API Access: Only for seller order import & shipment creation (no other use permitted)</li>
                        </ul>
                        <p>All third parties must comply with our Data Processing Agreements (DPA) and maintain ISO 27001 or equivalent security standards.</p>
                        <h3>Data Retention</h3>
                        <ul>
                        <li>Shipment records: 12 months minimum for legal & operational needs</li>
                        <li>KYC/financial data: Retained as per Indian law (up to 8 years)</li>
                        <li>Access logs: 90 days for monitoring, then securely deleted</li>
                        <li>Customer support queries: Deleted within 6 months post-resolution</li>
                        <li>Data deletion requests: Processed within 30 working days unless legally restricted</li>
                        </ul>
                        <h3>Your Rights</h3>
                        <p>Under DPDPA 2023 and GDPR principles, you may:</p>
                        <ul>
                        <li>Access your personal data (within 30 days of request)</li>
                        <li>Request corrections to inaccurate data</li>
                        <li>Request deletion (unless retention is legally required)</li>
                        <li>Withdraw consent for marketing communications</li>
                        <li>File a grievance with our Data Protection Officer (DPO)</li>
                        </ul>
                        <h3>Security Practices</h3>
                        <p>We implement layered security controls:</p>
                        <ul>
                        <li>Encryption: TLS 1.2+ in transit, AES-256 at rest</li>
                        <li>MFA: Mandatory for employee and admin accounts</li>
                        <li>Access Control: Role-based permissions, least privilege principle</li>
                        <li>Logging & Audits: All API access logged, anomalies flagged</li>
                        <li>Penetration Testing: Quarterly third-party audits performed</li>
                        <li>ISO 27001 Practices: Policy framework for IT & data handling</li>
                        </ul>
                        <h3>Cookies & Tracking</h3>
                        <p>We use cookies for:</p>
                        <ul>
                        <li>Website performance optimization</li>
                        <li>Authentication & session management</li>
                        <li>Analytics (Google Analytics, server logs)</li>
                        </ul>
                        <p>You may disable cookies, but some features may not function correctly.</p>
                        <h3>Policy Updates</h3>
                        <p>We may update this Privacy Policy. Users will be notified of significant changes via email or dashboard alerts. Continued use signifies acceptance</p>
                        <h3>Contact Us</h3>
                        <p>For privacy-related concerns:</p>
                        <p>Email:<a href="https://mail.google.com/mail/?view=cm&fs=1&to=support@parcelx.in" target="_blank" rel="noopener noreferrer"> support@parcelx.in</a></p>
                        <p> Address: Unit No. 8.4, 8th Floor, Eco Towers, Plot A-14, Sector-125, Noida – 201301, UP, India</p>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Privacy
